module.exports = __webpack_public_path__ + "img/GB16.0dcc43e9.webp";